import type { HTMLAttributes, ReactNode } from 'react';

export interface EmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  compact?: boolean;
}

export function EmptyState({
  title,
  description,
  icon,
  action,
  compact = false,
  className,
  ...emptyStateProps
}: EmptyStateProps) {
  const classes = ['ui-empty-state', compact ? 'ui-empty-state--compact' : '', className ?? '']
    .filter(Boolean).join(' ');

  return (
    <div {...emptyStateProps} className={classes}>
      {icon && <div className="ui-empty-state__icon" aria-hidden="true">{icon}</div>}
      <div className="ui-empty-state__content">
        <h2>{title}</h2>
        {description && <p>{description}</p>}
      </div>
      {action && <div className="ui-empty-state__action">{action}</div>}
    </div>
  );
}
